module.exports = __webpack_public_path__ + "static/img/16.89f86a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/16.png
// module id = RYXn
// module chunks = 0